import React from 'react';

const Talents = () => {
    return (
        <div>
            <p>This is Talents</p>
        </div>
    );
};

export default Talents;